module.exports = __webpack_public_path__ + "media/pl_pl_s1_Bozena.b95426af.oga";